export const setDates = (dates) => ({
   type: 'SET_DATES',
   payload: dates,
 });
 